/* eslint-disable consistent-return */
import React, { useState, useEffect } from 'react';
import { AiFillInfoCircle } from 'react-icons/ai';
import {
  AddMemberForm,
  Feedbacktext,
  InputLabel,
  InputWrapper,
  PopupInput,
  UpdateButton,
  ErrorText,
} from './editNftsElements';
import useAxiosPrivate from '../../../Hooks/useAxiosPrivate';

// REGEX
const EMAIL_REGEX = /^[a-z0-9]+@[a-z]+\.[a-z]{2,3}$/;

// Default state
const initialState = {
  nftID: '',
  wallet: '',
  prevOwner: '',
  hectare: '',
  mintDate: '',
  expDate: '',
};

const EditNftsPopup = ({
  setOpen, setData, selected, trigger, data,
}) => {
  const axiosPrivate = useAxiosPrivate();

  const [loading, setLoading] = useState(false);
  const [feedback, setFeedback] = useState('');
  const [state, setState] = useState(initialState);
  const [validEmail, setValidEmail] = useState(false);

  const handleInput = (e) => {
    const input = e.currentTarget.name;
    const { value } = e.currentTarget;

    setState((prev) => ({ ...prev, [input]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!state.wallet) {
      return setFeedback('Wallet cant be empty');
    }

    // Security
    const v1 = EMAIL_REGEX.test(state.email);

    if (state.email && !v1) {
      return setFeedback('Invalid email entry');
    }

    setLoading(true);

    axiosPrivate.post(
      '/editNft',
      JSON.stringify({
        nftID: state.nftID,
        email: state.email,
        wallet: state.wallet,
        prevOwner: state.prevOwner,
        hectare: state.hectare,
        mintDate: state.mintDate,
        expDate: state.expDate,
      }),
      {
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true,
      },
    ).then((res) => {
      if (res.data.status === 'error') {
        setLoading(false);
        setFeedback(res.data.message ? res.data.message : 'Something went wrong');
        setState(initialState);
      } else {
        setFeedback(res.data.message);
        const editedData = data.map((item) => {
          if (item.NFT_ID === selected.NFT_ID) {
            return {
              ...item,
              Email: state.email,
              Wallet_Address: state.wallet,
              Previous_Owner: state.prevOwner,
              Hectare: state.hectare,
              Mint_Date: state.mintDate,
              Exp_Date: state.expDate,
            };
          } return item;
        });
        setData(editedData);
        setState(initialState);
        setTimeout(() => {
          setLoading(false);
          setOpen(false);
          setFeedback('');
        }, 1000);
      }
    }).catch((error) => {
      setLoading(false);
      setFeedback(error.response?.data ? error.response.data.message : 'Something went wrong');
      setState(initialState);
    });
  };

  // Email verification
  useEffect(() => {
    const result = EMAIL_REGEX.test(state.email);
    setValidEmail(result);
  }, [state.email]);

  // Error handling
  useEffect(() => {
    if (state.email) { setFeedback(''); }
  }, [state.email]);

  useEffect(() => {
    setState({
      nftID: selected.NFT_ID,
      email: selected.Email ? selected.Email : '',
      wallet: selected.Wallet_Address ? selected.Wallet_Address : '',
      prevOwner: selected.Previous_Owner ? selected.Previous_Owner : '',
      hectare: selected.Hectare ? selected.Hectare : '',
      mintDate: selected.Mint_Date ? selected.Mint_Date : '',
      expDate: selected.Exp_Date ? selected.Exp_Date : '',
    });
  }, [trigger]);

  return (
    <AddMemberForm onSubmit={handleSubmit}>
      <InputWrapper>
        <InputLabel htmlFor="email">Email:</InputLabel>
        <PopupInput
          value={state.email}
          autoComplete="off"
          onChange={handleInput}
          aria-describedby="uidnote"
          type="email"
          name="email"
        />
      </InputWrapper>
      { state.email && !validEmail && (
      <ErrorText id="uidnote">
        <AiFillInfoCircle />
        &nbsp;
        Please enter a valid E-mail adress.
      </ErrorText>
      )}
      <InputWrapper>
        <InputLabel htmlFor="wallet">Wallet:</InputLabel>
        <PopupInput
          value={state.wallet}
          autoComplete="off"
          onChange={handleInput}
          aria-describedby="uidnote"
          type="text"
          name="wallet"
        />
      </InputWrapper>
      <InputWrapper>
        <InputLabel htmlFor="twitter">Prev owner:</InputLabel>
        <PopupInput
          value={state.prevOwner}
          autoComplete="off"
          onChange={handleInput}
          aria-describedby="uidnote"
          type="text"
          name="prevOwner"
        />
      </InputWrapper>
      <InputWrapper>
        <InputLabel htmlFor="discord">Hectare:</InputLabel>
        <PopupInput
          value={state.hectare}
          autoComplete="off"
          onChange={handleInput}
          aria-describedby="uidnote"
          type="text"
          name="hectare"
        />
      </InputWrapper>
      <UpdateButton disabled={loading} type="submit">{loading ? 'Editing nft' : 'Edit nft'}</UpdateButton>
      {feedback && <Feedbacktext>{feedback}</Feedbacktext>}
    </AddMemberForm>
  );
};

export default EditNftsPopup;
